import { customAxios } from './customAxios'

export function saveEsitoAdv(formValues,idPratica) {
const config = {
        params: { idPratica: idPratica },
        headers: {
            "AuthToken": JSON.parse(localStorage.getItem('token')),
        }
    }
const data = {
        "esitoAdv": formValues
    }

    return customAxios.post("/" + process.env.REACT_APP_PATH_NEW_PREFIX + "/saveEsitoADV", data, config)
}